var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartOutline = function SvgHeartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4578 5.54219C19.9691 5.05327 19.3889 4.66542 18.7503 4.40081C18.1117 4.1362 17.4272 4 16.7359 4C16.0446 4 15.3601 4.1362 14.7215 4.40081C14.0829 4.66542 13.5026 5.05327 13.0139 5.54219L11.9997 6.55639L10.9855 5.54219C9.99842 4.55507 8.6596 4.00051 7.26361 4.00051C5.86761 4.00051 4.52879 4.55507 3.54168 5.54219C2.55456 6.5293 2 7.86812 2 9.26412C2 10.6601 2.55456 11.9989 3.54168 12.9861L4.55588 14.0003L11.9997 21.4441L19.4436 14.0003L20.4578 12.9861C20.9467 12.4974 21.3346 11.9171 21.5992 11.2785C21.8638 10.6399 22 9.95539 22 9.26412C22 8.57285 21.8638 7.88835 21.5992 7.24973C21.3346 6.6111 20.9467 6.03088 20.4578 5.54219V5.54219Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeartOutline;